import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
    type IsoAndUnixTimestamp,
} from "@@/shared/date-time/iso-and-unix";
import {
    shippingIdZodSchema,
    type ShippingId,
} from "@@/shared/deliveries/shipping/shipping-id";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { providerIdZodSchema, type ProviderId } from "../provider-id";

type ProviderAddShippingCommand = {
    readonly _id: string;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _type: "PROVIDER_ADD_SHIPPING_COMMAND";
    readonly shippingId: ShippingId;
    readonly providerId: ProviderId;
};

type CreateCommandProps = Omit<
    ProviderAddShippingCommand,
    "_id" | "_type" | "_createdAt"
>;

const providerAddShippingCommandFactory = (params: CreateCommandProps) => {
    const command: ProviderAddShippingCommand = {
        ...params,
        _id: generateId({ prefix: "provider_add_shipping_command__" }),
        _type: "PROVIDER_ADD_SHIPPING_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const providerAddShippingCommandZodSchema: z.ZodSchema<ProviderAddShippingCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("PROVIDER_ADD_SHIPPING_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        shippingId: shippingIdZodSchema,
        providerId: providerIdZodSchema,
    });

export {
    providerAddShippingCommandFactory,
    providerAddShippingCommandZodSchema,
};
export type { ProviderAddShippingCommand };
